module.exports = __webpack_public_path__ + "static/img/bb.9873885f.svg";